export default function BackButton() {
  return (
    <svg
      width="22"
      height="22"
      viewBox="0 0 22 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <title>Back Button</title>
      <rect
        x="0.40918"
        y="0.512695"
        width="21.1082"
        height="21.1082"
        rx="10.5541"
        fill="#FBFBFB"
        fill-opacity="0.2"
      />
      <rect
        x="0.738995"
        y="0.84251"
        width="20.4485"
        height="20.4485"
        rx="10.2243"
        stroke="#FBFBFB"
        stroke-opacity="0.4"
        stroke-width="0.65963"
      />
      <path
        d="M11.7059 14.2538L8.29021 10.5908V11.486L11.7059 7.88184H10.0923L7.28906 10.7439V11.3328L10.0923 14.2538H11.7059ZM14.6386 11.6626V10.4613H8.38443V11.6626H14.6386Z"
        fill="#FBFBFB"
      />
    </svg>
  );
}
